<div mat-dialog-content>
  <div class="mat-dialog-header">
    <h3>Selecione quais documentos você deseja ver e/ou imprimir!</h3>
  </div>
  <div class="mat-dialog-content">
    <form class="form" [formGroup]="reportModel">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12">
          <ul>
            <li>
              <mat-checkbox (ngModelChange)="onChangeDownloadComplete($event)"
                formControlName="downloadCompleteReport">
                Download ficha completa
              </mat-checkbox>
            </li>
            @if (hasExternalExam && isCompletedReport) {
              <li>
                <mat-checkbox formControlName="examExternal">
                  Exames externo
                </mat-checkbox>
              </li>
            }
            @if (hasInternalExam && isCompletedReport) {
              <li>
                <mat-checkbox formControlName="examInternal">
                  Exames interno
                </mat-checkbox>
              </li>
            }
            @if (hasExternalPrescription && isCompletedReport) {
              <li>
                <mat-checkbox (ngModelChange)="onChangeExternal($event)"
                  formControlName="prescriptionExternal">
                  Prescrições Não padronizadas
                </mat-checkbox>
              </li>
            }
            @if (hasExternalPrescription && isCompletedReport) {
              <li>
                @if (checkedExternal) {
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Quantidade de Vias</mat-label>
                        <input formControlName="externalPrintCount" matInput type="number">
                      </mat-form-field>
                    </div>
                  </div>
                }
              </li>
            }
            @if (hasInternalPrescription && isCompletedReport) {
              <li>
                <mat-checkbox (ngModelChange)="onChangeInternal($event)"
                  formControlName="prescriptionInternal">
                  Prescrições Padronizadas
                </mat-checkbox>
              </li>
            }
            @if (hasInternalPrescription && isCompletedReport) {
              <li>
                @if (checkedInternal) {
                  <div class="row">
                    <div class="col-6 col-sm-6 col-md-6">
                      <mat-form-field appearance="outline">
                        <mat-label>Quantidade de Vias</mat-label>
                        <input formControlName="internalPrintCount" matInput type="number">
                      </mat-form-field>
                    </div>
                  </div>
                }
              </li>
            }
            @if (hasMedicalProcedure && isCompletedReport) {
              <li>
                <mat-checkbox formControlName="isMedicalProcedureReport">
                  Procedimentos Médicos
                </mat-checkbox>
              </li>
            }
            @if (isCompletedReport) {
              <li>
                <mat-checkbox formControlName="isEpisodeReport">
                  Ficha do episódio
                </mat-checkbox>
              </li>
            }
            @if (this.sickDaysOffAmount && this.sickDaysOffAmount > 0 && isCompletedReport) {
              <li>
                <mat-checkbox formControlName="sickNote">
                  Atestado
                </mat-checkbox>
              </li>
            }
            @if (this.datetimeEndIsolation && isCompletedReport) {
              <li>
                <mat-checkbox formControlName="isolation">
                  Notificação de Isolamento
                </mat-checkbox>
              </li>
            }
            @if (this.datetimeEndIsolation && isCompletedReport) {
              <li>
                <mat-checkbox formControlName="isolationAcknowledge">
                  Declaração de ciência de isolamento
                </mat-checkbox>
              </li>
            }
          </ul>
        </div>
      </div>
    </form>
    <div class="footer-panel-modal-list">
      <div class="row">
        <div class="col-6">
          @if (isLoading == false) {
            <button mat-flat-button color="primary" class="btn-block"
            (click)="clickOK()">Ok</button>
          }
          @if (isLoading == true) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </div>
      </div>
    </div>
  </div>
</div>